export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";